<div class="content-wrapper">
    <div class="content-body">
        <section id="my-wallet">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <h2 class="mt-5px">My Wallet</h2>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row shadow-bottom-light">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <h2 class="font-weight-bold">Total Balance</h2>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">
                                    <h2 class="text-primary font-weight-bold">
                                        &#8377;{{totalAmount | IndianNumber}}
                                    </h2>
                                </div>
                            </div>
                            <div class="row mt-20px">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <h6 class="text-italic">Wallet Amount</h6>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">
                                    <h6 class="text-italic">
                                        &#8377;{{userData?.wallet_amount | IndianNumber}}
                                    </h6>
                                </div>
                            </div>
                            <div class="row mt-10px">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <h6 class="text-italic">Activation Amount</h6>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">
                                    <h6 class="text-italic">
                                        &#8377;{{userData?.activation_amount | IndianNumber}}
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h4 class="font-weight-bold">Add money to wallet</h4>
                                </div>
                            </div>
                            <div class="row mt-10px">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label>Enter Amount</label>
                                    <input type="text" class="form-control" value="1000"/>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <button class="btn btn-warning mt-22px">Add Money to Wallet</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="text-italic font-weight-bold">Wallet Settings</h3>
                        </div>
                        <div class="card-body">
                            <h5 class="text-italic" (click)="goTo('transaction-history')">
                                <i class="fa fa-credit-card-alt mr-10px mt-5px" aria-hidden="true"></i><span class="cursor-pointer color-blue">View Transaction History</span>
                            </h5>
                            <h5 class="text-italic">
                                <i class="fa fa-key mr-10px mt-5px" aria-hidden="true"></i><span class="cursor-pointer color-blue">Change Transaction Password</span>
                            </h5>
                            <h5 class="text-italic" (click)="goTo('withdraw-activation-amount')">
                                <i class="fa fa-money mr-10px mt-5px" aria-hidden="true"></i><span class="cursor-pointer color-blue">Withdraw Activation Amount</span>
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
